<div class="cms-navbar">
  <div class="cms-navbar-title">
    {{expandNavbar ? 'Admin' : ''}}
  </div>
  <div class="cms-navbar-menu" #adminContent [style.width.px]='width' *ngIf="showAdminNav">
    <div class="dropdown">
      <div class="cms-navbar-menu-item">
        <i class="material-icons">content_copy</i>
        <div class="cms-navbar-menu-label" data-toggle="dropdown">{{expandNavbar ? 'Content' : ''}}</div>
        <ul class="dropdown-menu bmw-cms-navbar-dropdown">
          <li data-toggle="modal" data-target="#addNewContent" (click)='action="add"; clearContent()'>
            <a>
              <span>Add</span>
            </a>
          </li>
          <li data-toggle="modal" data-target="#editContent" (click)='action="edit"; clearContent()'>
            <a>
              <span>Edit</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="dropdown" *ngIf="!isMotorradAdmin || !isRollsRoyceAdmin">
      <div class="cms-navbar-menu-item">
        <i class="material-icons">people_outline</i>
        <div class="cms-navbar-menu-label" data-toggle="dropdown">{{expandNavbar ? 'Users' : ''}}</div>
        <ul class="dropdown-menu bmw-cms-navbar-dropdown">
          <li [routerLink]='["/show-users"]'>
            <a>
              <span>Manage Users</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="dropdown">
      <div class="cms-navbar-menu-item">
        <i class="material-icons">message</i>
        <div class="cms-navbar-menu-label" data-toggle="dropdown">{{expandNavbar ? 'Messages' : ''}}</div>
        <ul class="dropdown-menu bmw-cms-navbar-dropdown">
          <li [routerLink]='["/add-message"]'>
            <a>
              <span>New Message</span>
            </a>
          </li>
          <li [routerLink]='["/show-messages"]'>
            <a>
              <span>Edit/Delete Message</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="dropdown">
      <div class="cms-navbar-menu-item">
        <i class="material-icons">report</i>
        <div class="cms-navbar-menu-label" data-toggle="dropdown">{{expandNavbar ? 'Bulletin Reports' : ''}}</div>
        <ul class="dropdown-menu bmw-cms-navbar-dropdown">
          <li [routerLink]='["/show-bulletin-full-report"]'>
            <a>
              <span>Full Rating Report</span>
            </a>
          </li>
          <li [routerLink]='["/show-bulletin-avg-report"]'>
            <a>
              <span>Bulletin Average Rating Report</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="cms-toggle-navbar" (click)='toggleNavbar()'>
      <i class="material-icons">{{expandNavbar ? 'arrow_back' : 'arrow_forward'}}</i>
      <div class="cms-navbar-menu-label">{{expandNavbar ? 'Hide' : ''}}</div>
    </div>
  </div>
</div>

<div class="modal" id="addNewContent" role="dialog">
  <div class="bmw-csm-navbar-add-content modal-dialog">
    <div class="modal-content bmw-csm">
      <div class="modal-body">
        <div class="pull-right flex-container row">
          <i class="material-icons pointer" data-dismiss="modal" (click)='clearContent()'>close</i>
        </div>
        <div class="bmw-csm-navbar-modal-title">
          Add New Content
        </div>
        <span class="bmw-csm-modal-label">What type of content would you like to add?</span>
        <div class="bmw-cms-new-content-select">
          <select class="form-control" id="group" [(ngModel)]='inputContentType'>
            <option [ngValue]="undefined" disabled selected> Select Content Type </option>
            <option *ngFor="let content of contentsList" [ngValue]="content">{{content?.name}}</option>
          </select>
        </div>

        <div class="bmw-cms-modal-button">

          <button *ngIf='!((inputContentType?.id > 6 && inputContentType?.id < 10) || (inputContentType?.id > 12))'
            [style]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
            class="bmw-button-primary" data-toggle="modal" data-dismiss="modal" (click)='fetchUniqueDocNumber()'
            data-target="#addNewBulletin" [disabled]='inputContentType === undefined'>Next</button>

          <button *ngIf='inputContentType?.id > 6 && inputContentType?.id < 10'
            [style]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
            class="bmw-button-primary" data-toggle="modal" data-dismiss="modal"
            [routerLink]='["/add-video-tool-obd", inputContentType.name.toLowerCase(), action]'
            [disabled]='inputContentType === undefined'>Next</button>
          <button *ngIf='inputContentType?.id ===13 && action==="add"'
            [style]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
            class="bmw-button-primary" data-toggle="modal" data-dismiss="modal"
            [routerLink]='["/add-noise-catalog", inputContentType.name.toLowerCase(), action]'
            [disabled]='inputContentType === undefined'>Next</button>

          <button *ngIf='inputContentType?.id ===14 && action==="add"'
            [style]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
            class="bmw-button-primary" data-toggle="modal" data-dismiss="modal"
            [routerLink]='["/add-scope-pattern", inputContentType.name.toLowerCase(), action]'
            [disabled]='inputContentType === undefined'>Next</button>

          <div class="bmw-button-secondary" data-dismiss="modal">Cancel</div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="addNewBulletin" role="dialog" #addBulletinModal>
  <div class="bmw-cms-add-new-bulletin modal-dialog">
    <div class="modal-content bmw-csm">
      <div class="modal-body">
        <div class="pull-right flex-container row">
          <i class="material-icons pointer" data-dismiss="modal" (click)='clearContent()'>close</i>
        </div>
        <div class="bmw-csm-navbar-modal-title">
          Add {{inputContentType?.name}}
        </div>

        <div class="cms-modal-select-make-checkbox">
          <label class="container custombrandchbx" *ngFor='let make of makeList'>{{make?.makeName}}
            <input type="radio" name="radio" [value]="make" (change)="handleBrandChangeAdd()" [(ngModel)]='inputMake'>
            <span class="checkmark"></span>
          </label>
        </div>

        <div class="bmw-cms-add-bulletin-modal-content">
          <div *ngIf='inputContentType?.id === 1 || inputContentType?.id === 2'>
            <label>Main Group</label>
            <div class="bmw-cms-new-bulletin-select">
              <select class="form-control" id="group" [(ngModel)]='inputGroup'>
                <option [ngValue]="undefined" disabled selected> Select Main Group </option>
                <option *ngFor="let group of mainGroupList" [ngValue]="group">{{group}}</option>
              </select>
            </div>
            <div class="flex-container row">
              <div class="flex-50">
                <label>Date</label>
                <div class="bmw-cms-new-bulletin-datepicker">
                  <input type="date" name="mydate" id="mydate" [(ngModel)]="inputDate" placeholder="YYYY-MM-DD"
                    class="form-control" required />
                </div>
              </div>
            </div>
            <div class="flex-container row" *ngIf='showTakata'>
              <div class="flex-50">
                <label class="container is-takata-recall">Is Takata Recall?
                  <input type="checkbox" name="chechbox" value='isTakataRecall' [(ngModel)]='isTakataRecall'>
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="flex-50">
                <label>Takata Recall Code</label>
                <div>
                  <input type="text" name="tkr" [disabled]='!isTakataRecall' placeholder="ex 14V-428"
                    [(ngModel)]="tkrCode" required>
                </div>
              </div>
            </div>
            <div class="bmw-cms-ad-content-info-label">How would you like to add the bulletin?</div>
            <div class="bmw-cms-modal-button new-bulletin">
              <button [routerLink]='["/add-bulletin"]' [disabled]='!inputMake' class="bmw-button-secondary"
                data-dismiss="modal" (click)='holdUserInputs()'>Enter Manually</button>
            </div>
          </div>

          <div *ngIf='inputContentType?.id === 3'>
            <label>Main Group</label>
            <div class="bmw-cms-new-bulletin-select">
              <select class="form-control" id="group" [(ngModel)]='inputGroup'>
                <option [ngValue]="undefined" disabled selected> Select Main Group </option>
                <option *ngFor="let group of mainGroupList" [ngValue]="group">{{group}}</option>
              </select>
            </div>
            <div class="flex-container row">
              <div class="flex-50">
                <label>Date</label>
                <div>
                  <input type="date" name="mydate" [(ngModel)]="inputDate" class="form-control" required />
                </div>
              </div>
            </div>
            <div class="flex-container row">
              <div class="flex-50">
                <label>Bulletin Number</label>
                <div>
                  <input name="bulletinNumber" (keyup)="formatBulletinNumber($event)" type="text" maxlength="8"
                    placeholder="00 00 00" [(ngModel)]="bulletinNumber" required>
                </div>
              </div>
            </div>
            <div class="flex-container row" *ngIf='showTakata'>
              <div class="flex-50">
                <label class="container is-takata-recall">Is Takata Recall?
                  <input type="checkbox" name="chechbox" value='isTakataRecall' [(ngModel)]='isTakataRecall'>
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="flex-50">
                <label>Takata Recall Code</label>
                <div>
                  <input type="text" name="tkr" [disabled]='!isTakataRecall' placeholder="ex 14V-428"
                    [(ngModel)]="tkrCode" required>
                </div>
              </div>
            </div>
            <div class="bmw-cms-pbs-subject">
              <label>Subject</label>
              <textarea [(ngModel)]='textareaContent' placeholder="Enter Subject" maxlength="80"></textarea>
            </div>
            <div class="bmw-cms-modal-button new-bulletin">
              <div class="upload-btn-wrapper flex-150-px">
                <button class="btn pointer">Choose File</button>
                <input type="file" name="myfile" (change)='fileUpload($event)' />
              </div>
              <div class="bmw-bulletin-nofile-label flex">{{uploadedFileName}}</div>
            </div>
            <small style="color: red">{{errorMessage}}</small>
            <div class="bmw-cms-modal-button new-bulletin">
              <button [disabled]='!inputMake || !bulletinNumber' class="bmw-button-secondary"
                (click)='addPartsBulletin()'>Add Parts Bulletin</button>
            </div>
          </div>

          <div *ngIf='inputContentType?.id === 4'>
            <label>Main Group</label>
            <div class="bmw-cms-new-bulletin-select">
              <select class="form-control" id="group" [(ngModel)]='inputGroup'>
                <option [ngValue]="undefined" disabled selected> Select Main Group </option>
                <option *ngFor="let group of mainGroupList" [ngValue]="group">{{group}}</option>
              </select>
            </div>
            <div class="flex-container row">
              <div class="flex-50">
                <label>Date</label>
                <div>
                  <input type="date" name="mydate" [(ngModel)]="inputDate" class="form-control" required />
                </div>
              </div>
            </div>

            <div class="bmw-cms-pbs-subject">
              <label>Manual Name</label>
              <input [(ngModel)]='textareaContent' placeholder="Enter Subject" maxlength="50">
            </div>
            <div class="bmw-cms-modal-button new-bulletin">
              <div class="upload-btn-wrapper flex-150-px">
                <button class="btn pointer">Choose File</button>
                <input type="file" name="myfile" (change)='fileUpload($event)' />
              </div>
              <div class="bmw-bulletin-nofile-label flex">{{uploadedFileName}}</div>
            </div>
            <small style="color: red">{{errorMessage}}</small>
            <div class="bmw-cms-modal-button new-bulletin">
              <button [disabled]='!inputMake || !inputGroup' class="bmw-button-secondary"
                (click)='addOperatingFluidsDoc()'>Add Operating Fluid</button>
            </div>
          </div>

          <div *ngIf='inputContentType?.id === 5'>
            <div class="flex-container row">
              <div class="flex-50">
                <label>Number</label>
                <div>
                  <input name="mydate" placeholder="ex ST0000" [(ngModel)]="manualNumber" required>
                </div>
              </div>
              <div class="flex-50">
                <label>Date</label>
                <div>
                  <input type="date" name="mydate" class="form-control" [(ngModel)]="inputDate" required />
                </div>
              </div>
            </div>
            <div class="flex-container row" *ngIf='showTakata'>
              <div class="flex-50">
                <label class="container is-takata-recall">Is Takata Recall?
                  <input type="checkbox" name="chechbox" value='isTakataRecall' [(ngModel)]='isTakataRecall'>
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="flex-50">
                <label>Takata Recall Code</label>
                <div>
                  <input type="text" name="tkr" [disabled]='!isTakataRecall' placeholder="ex 14V-428"
                    [(ngModel)]="tkrCode" required>
                </div>
              </div>
            </div>
            <div class="bmw-cms-pbs-subject">
              <label>Course Name</label>
              <textarea [(ngModel)]='textareaContent' placeholder="Enter Course Name" maxlength="60"></textarea>
            </div>
            <div class="bmw-cms-modal-button new-bulletin">
              <div class="upload-btn-wrapper flex-150-px">
                <button class="btn pointer">Choose File</button>
                <input type="file" name="myfile" (change)='fileUpload($event)' />
              </div>
              <div class="bmw-bulletin-nofile-label flex">{{uploadedFileName}}</div>
            </div>
            <small style="color: red">{{errorMessage}}</small>
            <div class="bmw-cms-modal-button new-bulletin">
              <button [disabled]='!inputMake' class="bmw-button-secondary" (click)='addTechTrainingManual()'>Add
                Technical Training Manual</button>
            </div>
          </div>
          <div *ngIf='inputContentType?.id === 6'>
            <div class="flex-container row">
              <div class="flex-50">
                <label>Code</label>
                <div>
                  <input name="mydate" placeholder="ex SB000" [(ngModel)]="manualNumber" required>
                </div>
              </div>
              <div class="flex-50">
                <label>Date</label>
                <div>
                  <input type="date" name="mydate" class="form-control" [(ngModel)]="inputDate" required />
                </div>
              </div>
            </div>
            <div class="flex-container row" *ngIf='showTakata'>
              <div class="flex-50">
                <label class="container is-takata-recall">Is Takata Recall?
                  <input type="checkbox" name="chechbox" value='isTakataRecall' [(ngModel)]='isTakataRecall'>
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="flex-50">
                <label>Takata Recall Code</label>
                <div>
                  <input type="text" name="tkr" [disabled]='!isTakataRecall' placeholder="ex 14V-428"
                    [(ngModel)]="tkrCode" required>
                </div>
              </div>
            </div>
            <div class="bmw-cms-pbs-subject">
              <label>Title</label>
              <textarea [(ngModel)]='textareaContent' placeholder="Enter Title" maxlength="60"></textarea>
            </div>
            <div class="bmw-cms-modal-button new-bulletin">
              <div class="upload-btn-wrapper ">
                <button class="btn pointer">Choose File</button>
                <input type="file" name="myfile" (change)='fileUpload($event)' />
              </div>
              <div class="bmw-bulletin-nofile-label flex">{{uploadedFileName}}</div>
            </div>
            <small style="color: red">{{errorMessage}}</small>
            <div class="bmw-cms-modal-button new-bulletin">
              <button [disabled]='!inputMake' class="bmw-button-secondary" (click)='addBodyPaintManual()'>Add Body &
                Paint Manual</button>
            </div>
          </div>

          <div *ngIf='inputContentType?.id === 10'>
            <div class="flex-container row">
              <div class="flex-50">
                <label>Date</label>
                <div>
                  <input type="date" name="mydate" class="form-control" [(ngModel)]="inputDate" required />
                </div>
              </div>
              <div class="flex-50">
                <label>Category</label>
                <div>
                  <input name="category" placeholder="ex General" [(ngModel)]="manualCategory" required>
                </div>
              </div>
            </div>
            <div class="flex-container row">
              <div class="flex-50">
                <label>Code</label>
                <div>
                  <input name="manualNumber" disabled value={{uniqueDocNumber}} required>
                </div>
              </div>
            </div>
            <div class="flex-container row" *ngIf='showTakata'>
              <div class="flex-50">
                <label class="container is-takata-recall">Is Takata Recall?
                  <input type="checkbox" name="chechbox" value='isTakataRecall' [(ngModel)]='isTakataRecall'>
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="flex-50">
                <label>Takata Recall Code</label>
                <div>
                  <input type="text" name="tkr" [disabled]='!isTakataRecall' placeholder="ex 14V-428"
                    [(ngModel)]="tkrCode" required>
                </div>
              </div>
            </div>
            <div class="bmw-cms-pbs-subject">
              <label>Manual Name</label>
              <textarea [(ngModel)]='textareaContent' placeholder="Enter Manual Name" maxlength="80"
                required></textarea>
            </div>
            <div class="flex-container row">
              <div class="flex-50">
                <label class="container">File
                  <input type="radio" name="chkType" value='File' (change)="handleTypeValue()"
                    [(ngModel)]='chkTypeValue'>
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="flex-50">
                <label class="container">Hyperlink
                  <input type="radio" name="chkType" value='Link' (change)="handleTypeValue()"
                    [(ngModel)]='chkTypeValue'>
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <div class="bmw-cms-modal-button new-bulletin" *ngIf="chkTypeValue=='File'">
              <div class="upload-btn-wrapper ">
                <button class="btn pointer">Choose File</button>
                <input type="file" name="myfile" (change)='fileUpload($event)' />
              </div>
              <div class="bmw-bulletin-nofile-label flex">{{uploadedFileName}}</div>
            </div>
            <div class="bmw-cms-pbs-subject" *ngIf="chkTypeValue=='Link'">
              <label>Hyperlink</label>
              <textarea [(ngModel)]='textareaContentHyperlink' placeholder="Enter Hyperlink" maxlength="80"></textarea>
            </div>
            <small style="color: red">{{errorMessage}}</small>
            <div class="bmw-cms-modal-button new-bulletin">
              <button [disabled]='!inputMake' style="width: 175px" class="bmw-button-secondary"
                (click)='addEquipManual()'>Add Equipment Manual</button>
            </div>
          </div>

          <div *ngIf='inputContentType?.id === 12'>
            <div class="flex-container row">
              <div class="flex-50">
                <label>Code</label>
                <div>
                  <input name="manualNumber" disabled placeholder="ex SB000" value={{uniqueDocNumber}} required>
                </div>
              </div>
              <div class="flex-50">
                <label>Date</label>
                <div>
                  <input type="date" name="mydate" class="form-control" [(ngModel)]="inputDate" required />
                </div>
              </div>
            </div>
            <div class="flex-container row" *ngIf='showTakata'>
              <div class="flex-50">
                <label class="container is-takata-recall">Is Takata Recall?
                  <input type="checkbox" name="chechbox" value='isTakataRecall' [(ngModel)]='isTakataRecall'>
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="flex-50">
                <label>Takata Recall Code</label>
                <div>
                  <input type="text" name="tkr" [disabled]='!isTakataRecall' placeholder="ex 14V-428"
                    [(ngModel)]="tkrCode" required>
                </div>
              </div>
            </div>
            <div
              style="display: flex; box-sizing: border-box; flex-direction: column; -webkit-box-orient: horizontal; -webkit-box-direction: normal;">
              <div class="flex-25">
                <label>Category</label>
                <select class="form-control" id="categories" [(ngModel)]='inputCategories'
                  (change)='filterSubCategories()'>
                  <option [ngValue]="" selected>Select Category</option>
                  <option *ngFor="let categories of inputCategoriesGroup" [ngValue]="categories">{{ categories }}
                  </option>
                </select>
              </div>
              <div class="flex-25">
                <label>Sub-Category</label>
                <select class="form-control" id="subCategories" [(ngModel)]='inputSubCategories'
                  (change)='selectSubCategories()'>
                  <option [ngValue]="" selected>Select SubCategory</option>
                  <option *ngFor="let subCategories of inputSubCategoriesGroup" [ngValue]="subCategories">{{
                    subCategories }}</option>
                </select>
              </div>
            </div>
            <div class="flex-container row">
              <div class="flex-50">
                <label>New Category</label>
                <div>
                  <input name="category" placeholder="ex General" [(ngModel)]="newManualCategory"
                    [disabled]='newCategoryDisabled' required>
                </div>
              </div>
              <div class="flex-50">
                <label>New Sub-Category</label>
                <div>
                  <input name="subcategory" placeholder="ex General" [(ngModel)]="newManualSubCategory"
                    [disabled]='newSubCategoryDisabled' required>
                </div>
              </div>
            </div>
            <div class="bmw-cms-pbs-subject">
              <label>Document Name</label>
              <textarea [(ngModel)]='textareaContent' placeholder="Enter Document Name" maxlength="80"></textarea>
            </div>
            <div class="flex-container row">
              <div class="flex-50">
                <label class="container">File
                  <input type="radio" name="chkType" value='File' (change)="handleTypeValue()"
                    [(ngModel)]='chkTypeValue'>
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="flex-50">
                <label class="container">Hyperlink
                  <input type="radio" name="chkType" value='Link' (change)="handleTypeValue()"
                    [(ngModel)]='chkTypeValue'>
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <div class="bmw-cms-modal-button new-bulletin" *ngIf="chkTypeValue=='File'">
              <div class="upload-btn-wrapper flex-150-px">
                <button class="btn pointer">Choose File</button>
                <input type="file" name="myfile" (change)='fileUpload($event)' />
              </div>
              <div class="bmw-bulletin-nofile-label flex">{{uploadedFileName}}</div>
            </div>
            <div class="bmw-cms-pbs-subject" *ngIf="chkTypeValue=='Link'">
              <label>Hyperlink</label>
              <textarea [(ngModel)]='textareaContentHyperlink' placeholder="Enter Hyperlink" maxlength="80"></textarea>
            </div>
            <small style="color: red">{{errorMessage}}</small>
            <div class="bmw-cms-modal-button new-bulletin">
              <button [disabled]='!inputMake' style="width: 215px" class="bmw-button-secondary"
                (click)='addTechDoc()'>Add Technical Documentation</button>
            </div>
          </div>

          <div *ngIf='inputContentType?.id === 11'>
            <div style="margin-left: 7%" class="cms-modal-select-make-checkbox">
              <label class="container sm">FAQ
                <input type="radio" name="faq" value="faq" [(ngModel)]='faqOrTopLink'>
                <span class="checkmark"></span>
              </label>
              <label class="container sm" style="margin-right:0em;width:10em;margin-left:3em;">Top Link
                <input type="radio" name="topLink" value="topLink" [(ngModel)]='faqOrTopLink'>
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="flex-container row">
              <div class="flex-50">
                <label>Date</label>
                <div>
                  <input type="date" name="mydate" class="form-control" [(ngModel)]="inputDate" required />
                </div>
              </div>
            </div>
            <div class="bmw-cms-pbs-subject">
              <label>Document Name</label>
              <textarea [(ngModel)]='textareaContent' placeholder="Enter Document Name" maxlength="80"></textarea>
            </div>
            <div class="flex-container row">
              <div class="flex-50">
                <label class="container">File
                  <input type="radio" name="chkType" value='File' (change)="handleTypeValue()"
                    [(ngModel)]='chkTypeValue'>
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="flex-50">
                <label class="container">Hyperlink
                  <input type="radio" name="chkType" value='Link' (change)="handleTypeValue()"
                    [(ngModel)]='chkTypeValue'>
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <div class="bmw-cms-modal-button new-bulletin" *ngIf="chkTypeValue=='File'">
              <div class="upload-btn-wrapper ">
                <button class="btn pointer">Choose File</button>
                <input type="file" name="myfile" (change)='fileUpload($event)' />
              </div>
              <div class="bmw-bulletin-nofile-label flex">{{uploadedFileName}}</div>
            </div>
            <div class="bmw-cms-pbs-subject" *ngIf="chkTypeValue=='Link'">
              <label>Hyperlink</label>
              <textarea [(ngModel)]='textareaContentHyperlink' placeholder="Enter Hyperlink" maxlength="80"></textarea>
            </div>
            <small style="color: red">{{errorMessage}}</small>
            <div class="bmw-cms-modal-button new-bulletin">
              <button [disabled]='!inputMake || !faqOrTopLink' class="bmw-button-secondary"
                (click)='addFAQOrTopLink()'>Add FAQ/Top Link</button>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="editContent" role="dialog">
  <div class="bmw-csm-navbar-add-content modal-dialog">
    <div class="modal-content bmw-csm">
      <div class="modal-body">
        <div class="flex-container row" class="pull-right">
          <i class="material-icons pointer" data-dismiss="modal" (click)="clearContent()">close</i>
        </div>
        <div class="bmw-csm-navbar-modal-title">
          Edit Content
        </div>
        <span class="bmw-csm-modal-label">What type of content would you like to edit?</span>
        <div class="bmw-cms-new-content-select">
          <select class="form-control" id="group" [(ngModel)]='inputContentType'>
            <option [ngValue]="undefined" disabled selected> Select Content Type </option>
            <option *ngFor="let content of contentsList" [ngValue]="content">{{content?.name}}</option>
          </select>
        </div>

        <div class="bmw-cms-modal-button">

          <button *ngIf='inputContentType?.id < 3'
            [style]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
            class="bmw-button-primary" data-dismiss="modal" (click)='holdUserInputs()'
            [disabled]='inputContentType === undefined'>Next</button>

          <button
            *ngIf='!((inputContentType?.id > 6 && inputContentType?.id < 10) || (inputContentType?.id > 12)) && inputContentType?.id > 2'
            [style]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
            class="bmw-button-primary" data-toggle="modal" data-dismiss="modal"
            (click)='fetchApiData(inputContentType?.id)' data-target="#editBulletin"
            [disabled]='inputContentType === undefined'>Next</button>

          <button *ngIf='inputContentType?.id > 6 && inputContentType?.id < 10'
            [style]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
            class="bmw-button-primary" data-dismiss="modal"
            [routerLink]='["/add-video-tool-obd", inputContentType.name.toLowerCase(), action]'
            [disabled]='inputContentType === undefined'>Next</button>

          <button *ngIf='inputContentType?.id ===13 && action==="edit"'
            [style]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
            class="bmw-button-primary" data-toggle="modal" data-dismiss="modal"
            [routerLink]='["/edit-noise-catalog", inputContentType.name.toLowerCase(), action]'
            [disabled]='inputContentType === undefined'>Next</button>

          <button *ngIf='inputContentType?.id ===14 && action==="edit"'
            [style]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
            class="bmw-button-primary" data-dismiss="modal"
            [routerLink]='["/edit-scope-pattern", inputContentType.name.toLowerCase(), action]'
            [disabled]='inputContentType === undefined'>Next</button>

          <div class="bmw-button-secondary" data-dismiss="modal">Cancel</div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="editBulletin" role="dialog" #updateBulletinModal>
  <div class="bmw-cms-add-new-bulletin modal-dialog">
    <div class="modal-content bmw-csm">
      <div class="modal-body">
        <div class="flex-container row pull-right">
          <i class="material-icons pointer" data-dismiss="modal" (click)='clearContent()'>close</i>
        </div>
        <div class="bmw-csm-navbar-modal-title">
          Edit {{inputContentType?.name}}
        </div>

        <div class="cms-modal-select-make-checkbox">
          <label class="container custombrandchbx" *ngFor='let make of makeList'>{{make?.makeName}}
            <input type="radio" name="radio" [value]="make.makeName" (change)="handleBrandChange()"
              [(ngModel)]='inputMake'>
            <span class="checkmark"></span>
          </label>
        </div>

        <div class="bmw-cms-edit-bulletin-modal-content">
          <div *ngIf='inputContentType?.id === 1 || inputContentType?.id === 2'>
            <label>Main Group</label>
            <div class="bmw-cms-new-bulletin-select">
              <select class="form-control" id="group" [(ngModel)]='inputGroup'>
                <option [ngValue]="undefined" disabled selected> Select Main Group </option>
                <option *ngFor="let group of mainGroupList" [ngValue]="group">{{group}}</option>
              </select>
            </div>
            <div class="flex-container" *ngIf='showTakata'>
              <div class="flex-50">
                <label>Date</label>
                <div>
                  <input type="date" name="mydate" class="form-control" [(ngModel)]="inputDate" required />
                </div>
              </div>
              <div class="flex-50">
                <label>Takata Recall Code</label>
                <div>
                  <input name="tkr" placeholder="ex 14V-428" [(ngModel)]="tkrCode" required>
                </div>
              </div>
            </div>
            <div class="bmw-cms-ad-content-info-label">How would you like to add the bulletin?</div>
            <div class="bmw-cms-modal-button new-bulletin">
              <button class="bmw-button-secondary" data-dismiss="modal" (click)='holdUserInputs()'>Enter
                Manually</button>
            </div>
          </div>

          <div *ngIf='inputContentType?.id === 3'>
            <div class="flex-container">
              <div class="flex-70">
                <select class="form-control" id="group" [(ngModel)]='makeNameForApi'
                  style="width: 80%;margin-top: 30px; margin-left:3px">
                  <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="BMW">BMW</option>
                  <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="MINI">MINI</option>
                  <option *ngIf="isAdmin || isMotorradAdmin" value="MOTORRAD">MOTORRAD</option>
                  <option *ngIf="isAdmin || isRollsRoyceAdmin" value="ROLLSROYCE">ROLLSROYCE</option>
                </select>
                <div *ngIf="makeNameForApi === 'MOTORRAD'">
                  <div class="cms-modal-select-make-checkbox">
                    <label class="container">Current
                      <input type="radio" name="mcbulletininfo" value="mccurrent" [(ngModel)]="mcbinfo.options"
                        (change)="handleMcbInfoChange($event)">
                      <span class="checkmark"></span>
                    </label>
                    <label class="container">Legacy
                      <input type="radio" name="mcbulletininfo" value="mclegacy" [(ngModel)]="mcbinfo.options"
                        (change)="handleMcbInfoChange($event)">
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="invisible">...</div>
            <div class="invisible">...</div>
            <div class="invisible">...</div>
            <div class="flex-container">
              <div class="flex-30">
                <label>Bulletin Number</label>
              </div>
              <div class="bmw-bulletin-number flex-125-px" *ngIf="makeNameForApi === 'BMW' || makeNameForApi === 'MINI' || makeNameForApi === 'ROLLSROYCE' ||
                    (makeNameForApi === 'MOTORRAD' && showDefaultBn)">
                <input name="bulletinNumber" type="text" maxlength="8" placeholder="00 00 00"
                  (keyup)="formatBulletinNumber($event)" [(ngModel)]="bulletinNumber">
              </div>

              <div class="bmw-bulletin-number flex-300-px" *ngIf="makeNameForApi === 'MOTORRAD' && !showDefaultBn">
                <input name="bulletinNumber" type="text" [(ngModel)]='bulletinNumber'
                  placeholder="Enter Motorrad legacy bulletin number">
              </div>

              <div class="flex">
                <button style="margin: 0 0 0 0" [disabled]='!bulletinNumber || !makeNameForApi'
                  class="bmw-button-secondary" (click)='getPBSData(bulletinNumber, makeNameForApi)'>Find
                  Bulletin</button>
              </div>
            </div>
            <small style="font-weight: bold" [style]='{"color": isDocActive ? "#59a946" : "#8b928a"}'>
              {{isDocActive ? "Active" : "In-active"}}
            </small>
            <div *ngIf='bulletinData !== null'>
              <div class="flex-container" style="margin-top: 20px">
                <div class="flex-15">
                  <label>Main Group</label>
                </div>
                <div class="flex-65">
                  <div class="bmw-cms-new-bulletin-select">
                    <select class="form-control" id="group" [(ngModel)]='inputGroup'>
                      <option [ngValue]="undefined" disabled selected> Select Main Group </option>
                      <option *ngFor="let group of mainGroupList" [ngValue]="group">{{group}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="flex-container">
                <div class="flex-15">
                  <label>Date</label>
                </div>
                <div class="flex">
                  <div>
                    <input type="date" name="mydate" class="form-control" [(ngModel)]="inputDate" required />
                  </div>
                </div>
              </div>
              <div class="flex-container" *ngIf='showTakata'>
                <div class="flex-50">
                  <label class="container is-takata-recall">Is Takata Recall?
                    <input type="checkbox" name="chechbox" value='isTakataRecall' [(ngModel)]='isTakataRecall'>
                    <span class="checkmark"></span>
                  </label>
                </div>
                <div class="flex-50">
                  <label>Takata Recall Code</label>
                  <div>
                    <input type="text" name="tkr" [disabled]='!isTakataRecall' placeholder="ex 14V-428"
                      [(ngModel)]="tkrCode" required>
                  </div>
                </div>
              </div>
              <div class="bmw-cms-pbs-subject">
                <label>Subject</label>
                <textarea [(ngModel)]='textareaContent' placeholder="Enter Subject" maxlength="80"></textarea>
              </div>
              <div class="bmw-cms-modal-button new-bulletin">
                <div class="upload-btn-wrapper ">
                  <button class="btn pointer">Choose File</button>
                  <input type="file" name="myfile" (change)='fileUpload($event)' />
                </div>
                <div class="bmw-bulletin-nofile-label flex">{{uploadedFileName}}</div>
              </div>
              <div class="cms-modal-select-make-checkbox">
                <label class="container sm">Reactivate
                  <input type="radio" id="reactivatePbs" name="reactivatePbs" value="reactivate"
                    [(ngModel)]='reactivateOrDeactivate'>
                  <span class="checkmark"></span>
                </label>
                <label class="container sm" style="margin-right:0em;width:10em">Deactivate
                  <input type="radio" id="deactivatePbs" name="deactivatePbs" value="deactivate"
                    [(ngModel)]='reactivateOrDeactivate'>
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <small style="color: red">{{errorMessage}}</small>
            <div class="bmw-cms-modal-button new-bulletin">
              <button [disabled]='!bulletinNumber' class="bmw-button-secondary" (click)='updatePartsBulletin()'>Update
                Parts Bulletin</button>
            </div>
          </div>

          <div *ngIf='inputContentType?.id === 4'>
            <div class="flex-container row">
              <div class="flex-70">
                <div>
                  <label>Main Group</label>
                </div>
                <div>
                  <div class="bmw-cms-new-bulletin-select">
                    <select class="form-control" id="group" style="width: 95%" [(ngModel)]='inputGroup'>
                      <option [ngValue]="undefined" disabled selected> Select Main Group </option>
                      <option *ngFor="let group of mainGroupList" [ngValue]="group">{{group}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="flex">
                <select class="form-control" id="group" [(ngModel)]='makeNameForApi'
                  style="width:100%;margin-top: 25px; margin-left:3px">
                  <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="BMW">BMW</option>
                  <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="MINI">MINI</option>
                  <option *ngIf="isAdmin || isMotorradAdmin" value="MOTORRAD">MOTORRAD</option>
                  <option *ngIf="isAdmin || isRollsRoyceAdmin" value="ROLLSROYCE">ROLLSROYCE</option>
                </select>
              </div>
              <div class="flex">
                <i class="material-icons dp48 pointer submit"
                  (click)='fetchApiData(inputContentType?.id, makeNameForApi)'>keyboard_arrow_right</i>
              </div>
            </div>
            <div *ngIf='inputGroup?.length > 0'>
              <small style="font-weight: bold;margin-left: 10px"
                [style]='{"color": isDocActive ? "#59a946" : "#8b928a"}'>
                {{isDocActive ? "Active" : "In-active"}}
              </small>
              <div class="flex-container row">
                <div class="flex-15">
                  <label>Date</label>
                </div>
                <div class="flex">
                  <div>
                    <input type="date" name="mydate" class="form-control" [(ngModel)]="inputDate" required />
                  </div>
                </div>
              </div>

              <div class="bmw-cms-pbs-subject">
                <label>Manual Name</label>
                <input [(ngModel)]='textareaContent' placeholder="Enter Subject" maxlength="50">
              </div>
              <div class="bmw-cms-modal-button new-bulletin">
                <div class="upload-btn-wrapper ">
                  <button class="btn pointer">Choose File</button>
                  <input type="file" name="myfile" (change)='fileUpload($event)' />
                </div>
                <div class="bmw-bulletin-nofile-label flex">{{uploadedFileName}}</div>
              </div>
              <div class="cms-modal-select-make-checkbox">
                <label class="container sm">Reactivate
                  <input type="radio" id="reactivateOpFl" name="reactivate" value="reactivate"
                    [(ngModel)]='reactivateOrDeactivate'>
                  <span class="checkmark"></span>
                </label>
                <label class="container sm" style="margin-right:0em;width:10em">Deactivate
                  <input type="radio" id="deactivateOpFl" name="deactivate" value="deactivate"
                    [(ngModel)]='reactivateOrDeactivate'>
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <small style="color: red">{{errorMessage}}</small>
            <div class="bmw-cms-modal-button new-bulletin">
              <button [disabled]='!inputGroup || !makeNameForApi' style="width: auto" class="bmw-button-secondary"
                (click)='updateOperatingFluidsDoc()'>Update Operating Fluid</button>
            </div>
          </div>

          <div *ngIf='inputContentType?.id === 5'>
            <div class="flex-container row">
              <div class="flex-15">
                <select class="form-control" id="group" [(ngModel)]='makeNameForApi'
                  (change)='getAllTechTrainingManuals(makeNameForApi)'
                  style="width:80%;margin-left:5px;margin-top:25px">
                  <option value="undefined" disabled selected></option>
                  <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="BMW">BMW</option>
                  <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="MINI">MINI</option>
                  <option *ngIf="isAdmin || isMotorradAdmin" value="MOTORRAD">MOTORRAD</option>
                  <option *ngIf="isAdmin || isRollsRoyceAdmin" value="ROLLSROYCE">ROLLSROYCE</option>
                </select>
              </div>
              <div class="flex-40">
                <div>
                  <label>Number</label>
                </div>
                <div class="bmw-cms-new-bulletin-select">
                  <select style="width: 100%" class="form-control" id="group" [(ngModel)]='manualNumber'>
                    <option *ngFor="let docNumber of documentNumbersList" [ngValue]="docNumber">{{docNumber}}</option>
                  </select>
                </div>
              </div>

              <div class="flex">
                <i class="material-icons dp48 pointer submit"
                  (click)='getTechTrainingData(manualNumber, makeNameForApi)'>keyboard_arrow_right</i>
              </div>
            </div>
            <div *ngIf='manualNumber?.length > 0'>
              <small style="font-weight: bold;margin-left: 10px"
                [style]='{"color": isDocActive ? "#59a946" : "#8b928a"}'>
                {{isDocActive ? "Active" : "In-active"}}
              </small>
              <div class="flex-container row">
                <div class="flex-15">
                  <label>Date</label>
                </div>
                <div class="flex">
                  <div>
                    <input type="date" name="mydate" class="form-control" [(ngModel)]="inputDate" required />
                  </div>
                </div>
              </div>
              <div class="flex-container row" *ngIf='showTakata'>
                <div class="flex-50">
                  <label class="container is-takata-recall">Is Takata Recall?
                    <input type="checkbox" name="chechbox" value='isTakataRecall' [(ngModel)]='isTakataRecall'>
                    <span class="checkmark"></span>
                  </label>
                </div>
                <div class="flex-50">
                  <label>Takata Recall Code</label>
                  <div>
                    <input type="text" name="tkr" [disabled]='!isTakataRecall' placeholder="ex 14V-428"
                      [(ngModel)]="tkrCode" required>
                  </div>
                </div>
              </div>
              <div class="bmw-cms-pbs-subject">
                <label>Course Name</label>
                <textarea [(ngModel)]='textareaContent' placeholder="Enter Course Name" maxlength="60"></textarea>
              </div>
              <div class="bmw-cms-modal-button new-bulletin">
                <div class="upload-btn-wrapper flex-150-px">
                  <button class="btn pointer">Choose File</button>
                  <input type="file" name="myfile" (change)='fileUpload($event)' />
                </div>
                <div class="bmw-bulletin-nofile-label flex">{{uploadedFileName}}</div>
              </div>
              <div class="cms-modal-select-make-checkbox">
                <label class="container sm">Reactivate
                  <input type="radio" id="reactivateTechTrainingManual" name="reactivate" value="reactivate"
                    [(ngModel)]='reactivateOrDeactivate'>
                  <span class="checkmark"></span>
                </label>
                <label class="container sm" style="margin-right:0em;width:10em">Deactivate
                  <input type="radio" id="deactivateTechTrainingManual" name="deactivate" value="deactivate"
                    [(ngModel)]='reactivateOrDeactivate'>
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <small style="color: red">{{errorMessage}}</small>
            <div class="bmw-cms-modal-button new-bulletin">
              <button [disabled]='!makeNameForApi' class="bmw-button-secondary" style="width: auto"
                (click)='updateTechTrainingManual()'>Update Technical Training Manual</button>
            </div>
          </div>

          <div *ngIf='inputContentType?.id === 6'>
            <div class="flex-container row">
              <div class="flex-20">
                <select class="form-control" id="group" (change)='getAllBPMDocs(makeNameForApi)'
                  [(ngModel)]='makeNameForApi' style="width:80%; margin-left:5px;margin-top:25px;margin-right: 10px">
                  <option value="" disabled selected></option>
                  <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="BMW">BMW</option>
                  <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="MINI">MINI</option>
                  <option *ngIf="isAdmin || isMotorradAdmin" value="MOTORRAD">MOTORRAD</option>
                  <option *ngIf="isAdmin || isRollsRoyceAdmin" value="ROLLSROYCE">ROLLSROYCE</option>

                </select>
              </div>
              <div class="flex-40">
                <div>
                  <label>Number</label>
                </div>
                <div class="bmw-cms-new-bulletin-select">
                  <select style="width: 100%" [disabled]='!makeNameForApi' class="form-control" id="group"
                    [(ngModel)]='manualNumber'>
                    <option *ngFor="let docNumber of documentNumbersList" [ngValue]="docNumber">{{docNumber}}</option>
                  </select>
                </div>
              </div>
              <div class="flex">
                <i class="material-icons dp48 pointer submit"
                  (click)='getBodyPaintManualData(manualNumber, makeNameForApi)'>keyboard_arrow_right</i>
              </div>
            </div>
            <div *ngIf='manualNumber?.length > 0'>
              <small style="font-weight: bold;margin-left: 10px"
                [style]='{"color": isDocActive ? "#59a946" : "#8b928a"}'>
                {{isDocActive ? "Active" : "In-active"}}
              </small>
              <div class="flex-container row">
                <div class="flex-15">
                  <label>Date</label>
                </div>
                <div class="flex">
                  <div>
                    <input type="date" name="mydate" class="form-control" [(ngModel)]="inputDate" required />
                  </div>
                </div>
              </div>
              <div class="flex-container row" *ngIf='showTakata'>
                <div class="flex-50">
                  <label class="container is-takata-recall">Is Takata Recall?
                    <input type="checkbox" name="chechbox" value='isTakataRecall' [(ngModel)]='isTakataRecall'>
                    <span class="checkmark"></span>
                  </label>
                </div>
                <div class="flex-50">
                  <label>Takata Recall Code</label>
                  <div>
                    <input type="text" name="tkr" [disabled]='!isTakataRecall' placeholder="ex 14V-428"
                      [(ngModel)]="tkrCode" required>
                  </div>
                </div>
              </div>
              <div class="bmw-cms-pbs-subject">
                <label>Course Name</label>
                <textarea [(ngModel)]='textareaContent' placeholder="Enter Course Name" maxlength="60"></textarea>
              </div>
              <div class="bmw-cms-modal-button new-bulletin">
                <div class="upload-btn-wrapper flex-150-px">
                  <button class="btn pointer">Choose File</button>
                  <input type="file" name="myfile" (change)='fileUpload($event)' />
                </div>
                <div class="bmw-bulletin-nofile-label flex">{{uploadedFileName}}</div>
              </div>
              <div class="cms-modal-select-make-checkbox">
                <label class="container sm">Reactivate
                  <input type="radio" id="reactivateBpm" name="reactivate" value="reactivate"
                    [(ngModel)]='reactivateOrDeactivate'>
                  <span class="checkmark"></span>
                </label>
                <label class="container sm" style="margin-right:0em;width:10em">Deactivate
                  <input type="radio" id="deactivateBpm" name="deactivate" value="deactivate"
                    [(ngModel)]='reactivateOrDeactivate'>
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <small style="color: red">{{errorMessage}}</small>
            <div class="bmw-cms-modal-button new-bulletin">
              <button [disabled]='!makeNameForApi' class="bmw-button-secondary" (click)='updateBodyPaintManual()'>Update
                Body & Paint Manual</button>
            </div>
          </div>

          <div *ngIf='inputContentType?.id === 10'>
            <div class="flex-container row">
              <div class="flex-15">
                <select class="form-control" id="group" [(ngModel)]='makeNameForApi'
                  (change)='getAllEquipmentManuals(makeNameForApi)'
                  style="width:100%;margin-top: 25px; margin-left:5px">
                  <option value="" disabled selected></option>
                  <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="BMW">BMW</option>
                  <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="MINI">MINI</option>
                  <option *ngIf="isAdmin || isMotorradAdmin" value="MOTORRAD">MOTORRAD</option>
                  <option *ngIf="isAdmin || isRollsRoyceAdmin" value="ROLLSROYCE">ROLLSROYCE</option>
                </select>
              </div>
              <div class="flex-40">
                <label style="left: 15px;">Document Title</label>
                <div class="bmw-cms-new-bulletin-select">
                  <select style="width: 80%; margin-left: 15px; margin-top: 0px;" class="form-control"
                    [disabled]='!makeNameForApi' id="group" [(ngModel)]='manualNumber'>
                    <option *ngFor="let manual of equipManuals" [ngValue]="manual?.documentNumber">
                      {{manual?.documentTitle}}</option>
                  </select>
                </div>
              </div>

              <div class="flex-10">
                <i class="material-icons dp48 pointer submit" style="margin-top: 27px"
                  (click)='getEquipManualData(manualNumber, makeNameForApi)'>keyboard_arrow_right</i>
              </div>
            </div>
            <div *ngIf='manualNumber?.length > 0'>
              <small style="font-weight: bold;margin-left: 10px"
                [style]='{"color": isDocActive ? "#59a946" : "#8b928a"}'>
                {{isDocActive ? "Active" : "In-active"}}
              </small>
              <div class="flex-container row">
                <div class="flex-15">
                  <label>Date</label>
                </div>
                <div class="flex">
                  <div>
                    <input type="date" name="mydate" class="form-control" [(ngModel)]="inputDate" required />
                  </div>
                </div>
              </div>
              <div class="flex-container row" *ngIf='showTakata'>
                <div class="flex-50">
                  <label class="container is-takata-recall">Is Takata Recall?
                    <input type="checkbox" name="chechbox" value='isTakataRecall' [(ngModel)]='isTakataRecall'>
                    <span class="checkmark"></span>
                  </label>
                </div>
                <div class="flex-50">
                  <label>Takata Recall Code</label>
                  <div>
                    <input type="text" name="tkr" [disabled]='!isTakataRecall' placeholder="ex 14V-428"
                      [(ngModel)]="tkrCode" required>
                  </div>
                </div>
              </div>
              <div class="bmw-cms-pbs-subject">
                <label>Manual Name</label>
                <textarea [(ngModel)]='textareaContent' placeholder="Enter Manual Name" maxlength="80"
                  required></textarea>
              </div>
              <div class="flex-container row">
                <div class="flex-50">
                  <label class="container">File
                    <input type="radio" name="chkTypeEditEquipManual" value='File' (change)="handleTypeValue()"
                      [(ngModel)]='chkTypeValue'>
                    <span class="checkmark"></span>
                  </label>
                </div>
                <div class="flex-50">
                  <label class="container">Hyperlink
                    <input type="radio" name="chkTypeEditEquipManual" value='Link' (change)="handleTypeValue()"
                      [(ngModel)]='chkTypeValue'>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="bmw-cms-modal-button new-bulletin" *ngIf="chkTypeValue=='File'">
                <div class="upload-btn-wrapper ">
                  <button class="btn pointer">Choose File</button>
                  <input type="file" name="myfile" (change)='fileUpload($event)' />
                </div>
                <div class="bmw-bulletin-nofile-label flex">{{uploadedFileName}}</div>
              </div>
              <div class="bmw-cms-pbs-subject" *ngIf="chkTypeValue=='Link'">
                <label>Hyperlink</label>
                <textarea [(ngModel)]='textareaContentHyperlink' placeholder="Enter Hyperlink"
                  maxlength="80"></textarea>
              </div>
              <div class="cms-modal-select-make-checkbox">
                <label class="container sm">Reactivate
                  <input type="radio" id="reactivateEqManual" name="reactivate" value="reactivate"
                    [(ngModel)]='reactivateOrDeactivate'>
                  <span class="checkmark"></span>
                </label>
                <label class="container sm" style="margin-right:0em;width:10em">Deactivate
                  <input type="radio" id="deactivateEqManual" name="deactivate" value="deactivate"
                    [(ngModel)]='reactivateOrDeactivate'>
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <small style="color: red">{{errorMessage}}</small>
            <div class="bmw-cms-modal-button new-bulletin">
              <button [disabled]='!makeNameForApi' class="bmw-button-secondary" (click)='updateEquipManual()'>Update
                Equipment Manual</button>
            </div>
          </div>

          <div *ngIf='inputContentType?.id === 12'>
            <div class="flex-container row">
              <div class="flex-20">
                <select class="form-control" id="group" (change)='getAllTechDocs(makeNameForApi)'
                  [(ngModel)]='makeNameForApi' style="width:80%;margin-top: 5px; margin-left:5px">
                  <option value="" disabled selected></option>
                  <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="BMW">BMW</option>
                  <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="MINI">MINI</option>
                  <option *ngIf="isAdmin || isMotorradAdmin" value="MOTORRAD">MOTORRAD</option>
                  <option *ngIf="isAdmin || isRollsRoyceAdmin" value="ROLLSROYCE">ROLLSROYCE</option>
                </select>
              </div>
              <div class="flex-35">
                <input class='bmw-series-dropdown' list="series" id="seriesList" [(ngModel)]='userSelectedTechDoc'
                  name="seriesList" />
                <datalist id="series">
                  <option *ngFor="let doc of techDocAll" [ngValue]="doc">{{ doc?.documentTitleKey }}</option>

                </datalist>
              </div>

              <div class="flex">
                <i class="material-icons dp48 pointer submit" style="margin-top: 7px"
                  (click)='retrieveTechDoc(userSelectedTechDoc, makeNameForApi)'>keyboard_arrow_right</i>
              </div>
            </div>

            <div *ngIf='userSelectedTechDoc.length > 0'>
              <small style="font-weight: bold;margin-left: 10px"
                [style]='{"color": isDocActive ? "#59a946" : "#8b928a"}'>
                {{isDocActive ? "Active" : "In-active"}}
              </small>
              <div class="flex-container row">
                <div class="flex-50">
                  <label>Code</label>
                  <div>
                    <input name="manualNumber" disabled placeholder="ex SB000" value={{uniqueDocNumber}} required>
                  </div>
                </div>
                <div class="flex-50">
                  <label>Date</label>
                  <div>
                    <input type="date" name="mydate" class="form-control" [(ngModel)]="inputDate" required />
                  </div>
                </div>
              </div>
              <div class="flex-container row" *ngIf='showTakata'>
                <div class="flex-50">
                  <label class="container is-takata-recall">Is Takata Recall?
                    <input type="checkbox" name="chechbox" value='isTakataRecall' [(ngModel)]='isTakataRecall'>
                    <span class="checkmark"></span>
                  </label>
                </div>
                <div class="flex-50">
                  <label>Takata Recall Code</label>
                  <div>
                    <input type="text" name="tkr" [disabled]='!isTakataRecall' placeholder="ex 14V-428"
                      [(ngModel)]="tkrCode" required>
                  </div>
                </div>
              </div>
              <div
                style="display: flex; box-sizing: border-box; flex-direction: column; -webkit-box-orient: horizontal; -webkit-box-direction: normal;">
                <div class="flex-25">
                  <label>Category</label>
                  <select class="form-control" id="categories" [(ngModel)]='inputCategories'
                    (change)='filterSubCategories()'>
                    <option [ngValue]="" selected>Select Category</option>
                    <option *ngFor="let categories of inputCategoriesGroup" [ngValue]="categories">{{ categories }}
                    </option>
                  </select>
                </div>
                <div class="flex-25">
                  <label>Sub-Category</label>
                  <select class="form-control" id="subCategories" [(ngModel)]='inputSubCategories'
                    (change)='selectSubCategories()'>
                    <option [ngValue]="">Select SubCategory</option>
                    <option *ngFor="let subCategories of inputSubCategoriesGroup" [ngValue]="subCategories">{{
                      subCategories }}</option>
                  </select>
                </div>
              </div>
              <div class="flex-container row">
                <div class="flex-50">
                  <label>New Category</label>
                  <div>
                    <input name="category" placeholder="ex General" [(ngModel)]="newManualCategory"
                      [disabled]='newCategoryDisabled' required>
                  </div>
                </div>
                <div class="flex-50">
                  <label>New Sub-Category</label>
                  <div>
                    <input name="subcategory" placeholder="ex General" [(ngModel)]="newManualSubCategory"
                      [disabled]='newSubCategoryDisabled' required>
                  </div>
                </div>
              </div>
              <div class="bmw-cms-pbs-subject">
                <label>Document Name</label>
                <textarea [(ngModel)]='textareaContent' placeholder="Enter Document Name" maxlength="80"></textarea>
              </div>
              <div class="flex-container row">
                <div class="flex-50">
                  <label class="container">File
                    <input type="radio" name="chkTypeEditTechDoc" value='File' (change)="handleTypeValue()"
                      [(ngModel)]='chkTypeValue'>
                    <span class="checkmark"></span>
                  </label>
                </div>
                <div class="flex-50">
                  <label class="container">Hyperlink
                    <input type="radio" name="chkTypeEditTechDoc" value='Link' (change)="handleTypeValue()"
                      [(ngModel)]='chkTypeValue'>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="bmw-cms-modal-button new-bulletin" *ngIf="chkTypeValue=='File'">
                <div class="upload-btn-wrapper flex-22">
                  <button class="btn pointer">Choose File</button>
                  <input type="file" name="myfile" (change)='fileUpload($event)' />
                </div>
                <div class="bmw-bulletin-nofile-label flex-75">{{uploadedFileName}}</div>
              </div>
              <div class="bmw-cms-pbs-subject" *ngIf="chkTypeValue=='Link'">
                <label>Hyperlink</label>
                <textarea [(ngModel)]='textareaContentHyperlink' placeholder="Enter Hyperlink"
                  maxlength="80"></textarea>
              </div>
              <div class="cms-modal-select-make-checkbox">
                <label class="container sm">Reactivate
                  <input type="radio" id="reactivateTechDoc" name="reactivate" value="reactivate"
                    [(ngModel)]='reactivateOrDeactivate'>
                  <span class="checkmark"></span>
                </label>
                <label class="container sm" style="margin-right:0em;width:10em">Deactivate
                  <input type="radio" id="deactivateTechDoc" name="deactivate" value="deactivate"
                    [(ngModel)]='reactivateOrDeactivate'>
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <small style="color: red">{{errorMessage}}</small>
            <div class="bmw-cms-modal-button new-bulletin">
              <button [disabled]='!makeNameForApi' class="bmw-button-secondary" style="width: auto"
                (click)='updateTechDoc()'>Update Technical Documentation</button>
            </div>
          </div>

          <div *ngIf='inputContentType?.id === 11'>
            <div>
              <div class="flex-20">
                <select class="form-control" id="group" [(ngModel)]='makeNameForApi'
                  style="width:80%;margin-left:5px;margin-top:5rem">
                  <option value="undefined" disabled selected></option>
                  <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="BMW">BMW</option>
                  <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="MINI">MINI</option>
                  <option *ngIf="isAdmin || isMotorradAdmin" value="MOTORRAD">MOTORRAD</option>
                  <option *ngIf="isAdmin || isRollsRoyceAdmin" value="ROLLSROYCE">ROLLSROYCE</option>
                </select>
              </div>
              <div class="flex-20">
                <select class="form-control" id="group" style="width:80%;margin-left:5px;margin-top:5rem"
                  [disabled]='!makeNameForApi' [(ngModel)]='faqOrTopLink'
                  (change)='getfaqTopLinks(faqOrTopLink, makeNameForApi)'>
                  <option value="undefined" disabled selected></option>
                  <option value="faq">FAQ</option>
                  <option value="topLink">Top Links</option>
                </select>
              </div>
              <div class="flex-50">
                <div>
                  <label>Title</label>
                </div>
                <div class="bmw-cms-new-bulletin-select">
                  <select style="width: 90%" class="form-control" style="width:100%;margin-left:5px;margin-top:25px"
                    id="group" [(ngModel)]='faqTopLinkDoc'>
                    <option *ngFor="let link of faqTopLinks" [ngValue]="link">{{link?.documentTitle}}</option>
                  </select>
                </div>
              </div>
              <div class="flex">
                <i class="material-icons dp48 pointer submit" style="margin-top:5rem"
                  (click)='getFaqTopLinksData(faqTopLinkDoc, makeNameForApi)'>keyboard_arrow_right</i>
              </div>
            </div>
            <div *ngIf='faqTopLinkDoc?.id'>
              <small style="font-weight: bold;margin-left: 10px"
                [style]='{"color": isDocActive ? "#59a946" : "#8b928a"}'>
                {{isDocActive ? "Active" : "In-active"}}
              </small>
              <div class="flex-container row">
                <div class="flex-15">
                  <label>Date</label>
                </div>
                <div class="flex">
                  <div>
                    <input type="date" name="mydate" class="form-control" [(ngModel)]="inputDate" required />
                  </div>
                </div>
              </div>
              <div class="bmw-cms-pbs-subject">
                <label>Document Name</label>
                <textarea [(ngModel)]='textareaContent' placeholder="Enter Document Name" maxlength="80"></textarea>
              </div>
              <div class="flex-container row">
                <div class="flex-50">
                  <label class="container">File
                    <input type="radio" name="chkTypeEditFaqTop" value='File' (change)="handleTypeValue()"
                      [(ngModel)]='chkTypeValue'>
                    <span class="checkmark"></span>
                  </label>
                </div>
                <div class="flex-50">
                  <label class="container">Hyperlink
                    <input type="radio" name="chkTypeEditFaqTop" value='Link' (change)="handleTypeValue()"
                      [(ngModel)]='chkTypeValue'>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="bmw-cms-modal-button new-bulletin" *ngIf="chkTypeValue=='File'">
                <div class="upload-btn-wrapper ">
                  <button class="btn pointer">Choose File</button>
                  <input type="file" name="myfile" (change)='fileUpload($event)' />
                </div>
                <div class="bmw-bulletin-nofile-label flex">{{uploadedFileName}}</div>
              </div>
              <div class="bmw-cms-pbs-subject" *ngIf="chkTypeValue=='Link'">
                <label>Hyperlink</label>
                <textarea [(ngModel)]='textareaContentHyperlink' placeholder="Enter Hyperlink"
                  maxlength="80"></textarea>
              </div>
              <div class="cms-modal-select-make-checkbox">
                <label class="container sm">Reactivate
                  <input type="radio" id="reactivateFaqTopLink" name="reactivate" value="reactivate"
                    [(ngModel)]='reactivateOrDeactivate' (click)="reactivateOrDeactivateFaqTopLink('reactivate')">
                  <span class="checkmark"></span>
                </label>
                <label class="container sm" style="margin-right:0em;width:10em">Deactivate
                  <input type="radio" id="deactivateFaqTopLink" name="deactivate" value="deactivate"
                    [(ngModel)]='reactivateOrDeactivate' (click)="reactivateOrDeactivateFaqTopLink('deactivate')">
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <small style="color: red">{{errorMessage}}</small>
            <div class="bmw-cms-modal-button new-bulletin">
              <button [disabled]='!makeNameForApi' style="margin-left:35%" class="bmw-button-secondary"
                (click)='updateFAQOrTopLink()'>Update FAQ/Top Link</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>